import React, {useEffect, useState} from 'react';
import T from 'prop-types';
import {useFormikContext} from 'formik';
import SelectRow from 'routes/App/settings/DeliveryHoursPicker/DaysPickerTimeSelect/SelectRow';
import {DashboardTime} from 'routes/App/dashboard/styles';
import {generateTimeRanges} from 'routes/App/settings/helpers';
import {
  useDeliveryHoursContext,
  useDeliveryHoursContextUpdate
} from 'routes/App/settings/DeliveryHoursPicker/context/DaysPickerContext';
import {isValueObjChanged} from 'helpers/functionUtils/dayAndTimePickerUtils';

const DaysPickerTimeSelect = ({timePeriods, day}) => {
  const [timeRanges, setTimeRanges] = useState(generateTimeRanges(15, 'en'));
  const deliveryDays = useDeliveryHoursContext();
  const setDeliveryDays = useDeliveryHoursContextUpdate();
  const {
    setFieldValue,
    values: {DeliveryHoursChanged}
  } = useFormikContext();

  const removeTimePeriods = (periodId) => {
    const arr = [...deliveryDays];
    const elementId = arr.findIndex((d) => d.id === day.id);
    arr[elementId].timePeriods = arr[elementId].timePeriods.filter(
      (d) => d.id !== periodId
    );
    setDeliveryDays(arr);

    setFieldValue(
      'DeliveryHoursChanged',
      isValueObjChanged(DeliveryHoursChanged, periodId)
    );
  };

  const entryCheck = (arr1, arr2) => {
    return !arr1.find((elem) => {
      return arr2.indexOf(elem) === -1;
    });
  };

  useEffect(() => {
    const nextIntervals = generateTimeRanges(15, 'en');

    timePeriods.forEach((period) => {
      timePeriods.forEach((mapPeriod) => {
        if (
          mapPeriod.id !== period.id &&
          mapPeriod.hoursIntervals.length &&
          entryCheck(mapPeriod.hoursIntervals, period.hoursIntervals)
        ) {
          removeTimePeriods(mapPeriod.id);
        }
      });
      period.hoursIntervals.forEach((interval) => {
        if (Object.prototype.hasOwnProperty.call(nextIntervals, interval)) {
          nextIntervals[interval] = true;
        }
      });
    });

    setTimeRanges(nextIntervals);
  }, [day, deliveryDays, timePeriods]);

  return (
    <>
      {day.timePeriods.map((period) => (
        <DashboardTime className='mLeft' key={`period-${period.id}`}>
          <SelectRow period={period} timeRanges={timeRanges} day={day} />
        </DashboardTime>
      ))}
    </>
  );
};

DaysPickerTimeSelect.propTypes = {
  timePeriods: T.array.isRequired,
  day: T.object.isRequired
};

export default DaysPickerTimeSelect;
